"use client";

import type { FC } from "react";
import { cn } from "utils";
import { PortfolioScreenshotImageList } from "./PortfolioScreenshotImageList";
import { PortfolioScreenshotRecognizeError } from "./PortfolioScreenshotRecognizeError";
import type { SenderAttachment } from "@components/Sender/type";

export type PortfolioScreenshotImageSectionProps = {
  images: SenderAttachment[];
  canAddMore: boolean;
  recognizeError: string | null;
  onRemove: (index: number) => void;
  onPickMore: () => void;
  chipNameClassName?: string;
  className?: string;
};

export const PortfolioScreenshotImageSection: FC<
  PortfolioScreenshotImageSectionProps
> = ({
  images,
  canAddMore,
  recognizeError,
  onRemove,
  onPickMore,
  chipNameClassName,
  className,
}) => {
  return (
    <div className={cn("flex w-full flex-col gap-2", className)}>
      <PortfolioScreenshotImageList
        images={images}
        canAddMore={canAddMore}
        chipNameClassName={chipNameClassName}
        onRemove={onRemove}
        onPickMore={onPickMore}
      />
      {recognizeError ? (
        <PortfolioScreenshotRecognizeError message={recognizeError} />
      ) : null}
    </div>
  );
};
